import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../css/AddUnit.css";

const AddSupplier = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const API_URL = process.env.REACT_APP_API_URL || "";

    const [supplierName, setSupplierName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [time, setTime] = useState("");

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [toast, setToast] = useState({ show: false, message: "", type: "" });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (id) {
            setLoading(true);
            fetch(`${API_URL}supplier-get.php?id=${id}`)
                .then(res => res.json())
                .then(data => {
                    if (data.supplier) {
                        setSupplierName(data.supplier.suppliername || "");
                        setPhone(data.supplier.phone || "");
                        setEmail(data.supplier.email || "");
                        setAddress(data.supplier.address || "");
                        setTime(data.supplier.time || new Date().toISOString());
                    }
                })
                .catch(() => {
                    showToast("Failed to load supplier data.", "error");
                })
                .finally(() => setLoading(false));
        } else {
            // RESET FIELDS HERE
            setSupplierName("");
            setPhone("");
            setEmail("");
            setAddress("");
            setTime(new Date().toISOString());
        }
    }, [id, API_URL]);

    const showToast = (message, type = "success") => {
        setToast({ show: true, message, type });
        setTimeout(() => {
            setToast({ show: false, message: "", type: "" });
        }, 3000);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        let response, data;
        try {
            if (id) {
                // Edit: send JSON
                response = await fetch(`${API_URL}edit-supplier.php`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        supplier_id: id,
                        suppliername: supplierName,
                        phone: phone,
                        email: email,
                        address: address,
                    }),
                });
            } else {
                // Add: send FormData
                const formData = new FormData();
                formData.append("suppliername", supplierName);
                formData.append("phone", phone);
                formData.append("email", email);
                formData.append("address", address);
                response = await fetch(`${API_URL}add-supplier.php`, {
                    method: "POST",
                    body: formData,
                });
            }
            data = await response.json();

            if (
                data.message &&
                (data.message.toLowerCase().includes("successfully") || data.message.toLowerCase().includes("updated") || data.message.toLowerCase().includes("added"))
            ) {
                showToast(data.message, "success");
                setTimeout(() => navigate("/supplier-list"), 1500);
            } else {
                showToast(data.message || (id ? "Failed to update supplier." : "Failed to add supplier."), "error");
            }
        } catch (error) {
            showToast("Network error. Please try again.", "error");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="add-category-content">
            <div className="page-header" style={{ display: "block" }}>
                <h1>{id ? "Edit Supplier" : "Add Supplier"}</h1>
                <p>{id ? "Edit supplier profile" : "Create a new supplier profile"}</p>
            </div>
            <div className="form-container">
                <form onSubmit={handleSubmit} className="add-unit-form">
                    <div className="form-group">
                        <label htmlFor="supplierName">Supplier Name</label>
                        <input
                            type="text"
                            id="supplierName"
                            value={supplierName}
                            onChange={(e) => setSupplierName(e.target.value)}
                            required
                            disabled={isSubmitting || loading}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="phone">Phone</label>
                        <input
                            type="tel"
                            id="phone"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            required
                            disabled={isSubmitting || loading}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            disabled={isSubmitting || loading}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="address">Address</label>
                        <textarea
                            id="address"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            required
                            disabled={isSubmitting || loading}
                        ></textarea>
                    </div>
                    <button type="submit" className="submit-btn" disabled={isSubmitting || loading}>
                        {loading ? (id ? "Loading..." : "Loading...") : isSubmitting ? (id ? "Updating..." : "Adding...") : id ? "Update Supplier" : "Add Supplier"}
                    </button>
                </form>
            </div>
            {toast.show && (
                <div className={`toast toast-${toast.type}`}>
                    <div className="toast-content">
                        <span className="toast-message">{toast.message}</span>
                        <button
                            className="toast-close"
                            onClick={() => setToast({ show: false, message: "", type: "" })}
                        >
                            ×
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddSupplier;